import styles from './AppHeader.module.css'

interface AppHeaderProps {
  title: string
  canGoBack: boolean
  onBack: () => void
  onSettings: () => void
}

/**
 * RTL: the back glyph is → and the forward affordance is ←. Do not flip them —
 * in an RTL layout the arrow pointing right is the one that means "back".
 */
export function AppHeader({ title, canGoBack, onBack, onSettings }: AppHeaderProps) {
  return (
    <header className={styles.header}>
      {canGoBack ? (
        <button type="button" className={styles.iconButton} onClick={onBack} aria-label="بازگشت">
          &#x2192;
        </button>
      ) : (
        <div className={styles.spacer} aria-hidden="true" />
      )}

      <h1 className={styles.title}>{title}</h1>

      <button type="button" className={styles.iconButton} onClick={onSettings} aria-label="تنظیمات">
        ⚙
      </button>
    </header>
  )
}
